import { render, staticRenderFns } from "./AsideList.vue?vue&type=template&id=56b70d0a"
import script from "./AsideList.vue?vue&type=script&lang=js"
export * from "./AsideList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports